import { render, staticRenderFns } from "./ReelView.vue?vue&type=template&id=764e9610&scoped=true"
import script from "./ReelView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReelView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReelView.vue?vue&type=style&index=0&id=764e9610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e9610",
  null
  
)

export default component.exports